import React from "react";
import "../assets/css/floating.css";
import phoneIcon from "../assets/images/phoneIcon.svg";

export const Floating = (data) => {
  const url = window.location.pathname;
  const phone = data.data.phoneNumber
  const numberIcon = data.data.phoneNumberIcon
  return (
    <div className="floating-button" type="button">
      <img src={phoneIcon} alt="Phone" className="phoneIcon" />
      {url === "/seguridad" ? (
          <a href="tel:08003451886">
            {window.innerWidth < 1001 ? (
              <div>
                <b>0800 345 1886</b>
              </div>
            ):(
              <div>
                <span>Obtener promo </span> <b>0800 345 1886</b>
              </div>
            )}
          </a>
        ) : (
          <a href={`tel:${phone}`}>
            {window.innerWidth < 1001 ? (
              <div>
                <b>{numberIcon}</b>
              </div>
            ):(
              <div>
                <span>Obtener promo </span><b>{numberIcon}</b>
              </div>
            )}
          </a>
        )}
    </div>
  );
};
